import React from 'react';
import SEO from '../components/common/SEO';
import PanchangHero from '../components/home/PanchangHero';
import Hero from '../components/home/Hero';
import ServicesGrid from '../components/home/ServicesGrid';
import HoroscopePreview from '../components/home/HoroscopePreview';
import WhyChooseUs from '../components/home/WhyChooseUs';
import Testimonials from '../components/home/Testimonials';
import CTASection from '../components/home/CTASection';

const Home = () => {
  return (
    <main>
      <SEO
        description="AstroEpanchang - India's #1 Vedic Astrology platform. Get free birth charts, daily horoscopes, panchang, marriage matching, zodiac signs, and Hindu festival dates."
        keywords="vedic astrology, horoscope, kundli, birth chart, panchang, zodiac, daily horoscope, epanchang, hindu festivals, muhurtham"
        canonicalPath="/"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "WebSite",
          "name": "AstroEpanchang",
          "url": "https://www.astroepanchang.com",
          "description": "Premium Vedic Astrology, Birth Charts, Daily Horoscopes & Zodiac Insights",
          "potentialAction": {
            "@type": "SearchAction",
            "target": "https://www.astroepanchang.com/horoscope/{search_term_string}",
            "query-input": "required name=search_term_string"
          }
        }}
      />
      <PanchangHero />
      <Hero />
      <ServicesGrid />
      <HoroscopePreview />
      <WhyChooseUs />
      <Testimonials />
      <CTASection />
    </main>
  );
};

export default Home;
